<template>
  <div>
     <section id="page-title">
        <div class="container clearfix">
          <h1 data-animate="fadeInUp">2017 SPRING</h1>
          <span data-delay="300" data-animate="fadeInUp">Little Mermaid</span> 
        </div>
      </section>
      <section id="content">
            <div class="content-wrap">
                <div class="container clearfix">
                    <!-- Portfolio Filter
============================================= -->
                    <!-- #portfolio-filter end -->
                    <div class="clear"></div>
                    <!-- Portfolio Items
============================================= -->
                    <div id="portfolio" class="portfolio-masonry clearfix">
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic2.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic2.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>

                        
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic3.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic3.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic4.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic4.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic5.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic5.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic6.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic6.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic7.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic7.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic8.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic8.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic9.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic9.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/sv101.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/v01.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/sv102.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/v02.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/sv103.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/v03.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/sv104.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/v04.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic10.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic10.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic11.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic11.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic12.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic12.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic13.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic13.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic14.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic14.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic15.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic15.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic16.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic16.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic17.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic17.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic18.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic18.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic19.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic19.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic20.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic20.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic21.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic21.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic22.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic22.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic23.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic23.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic24.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic24.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic25.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic25.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>

                    </div>
                </div>
            </div>
        </section>
        <!-- #content end -->
  </div>
</template>
<script>
    import jQuery from 'jquery'
    export default {
    name: "2017Spring",
    components: {
    },
    mounted(){
        jQuery(window).load(function() {

        var $container = jQuery('#portfolio');

        $container.isotope({
            transitionDuration: '0.65s'
        });

        jQuery('#portfolio-filter a').click(function() {
            jQuery('#portfolio-filter li').removeClass('activeFilter');
            jQuery(this).parent('li').addClass('activeFilter');
            var selector = $(this).attr('data-filter');
            $container.isotope({
                filter: selector
            });
            return false;
        });

        jQuery('#portfolio-shuffle').click(function() {
            $container.isotope('updateSortData').isotope({
                sortBy: 'random'
            });
        });

        jQuery(window).resize(function() {
            $container.isotope('layout');
        });

    });
    }
  }
</script>
